import React from 'react'

import '../../styles/toast.scss'

export default function AlertToast({ timestap, content, close }) {
    const isFinish = React.useRef(false)
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            isFinish.current = true
            close()
        }, 3000)
        isFinish.current = false
        return () => {
            clearInterval(timeout)
            if (!isFinish.current) {
                close()
            }
        }
    }, [timestap])

    return (
        <div className="user-alert-container toast">
            <div className="alert-toast-container">
                <div className="alert-toast-content">{content}</div>
            </div>
        </div>
    )
}
